<mat-card class="card-linnks margin-linnks">
  <mat-card-title>
    {{title}}
    <mat-card-subtitle>
      {{subtitle}}
    </mat-card-subtitle>
  </mat-card-title>
  <mat-card-content>
    <div class="box-content">
      <p-table class="table-system" #dt1 [value]="pendencias" [rows]="rows" [paginator]="true" [pageLinks]="pageLinks"
        [rowsPerPageOptions]="rowsPerPage">

        <ng-template pTemplate="header">
          <tr>
            <th class="text-left" style="width: 30%;">
              <span class="text-overflow-dynamic-container" [pSortableColumn]="'obrigacao'">
                <span class="text-overflow-dynamic-ellipsis">Obrigação <p-sortIcon [field]="'obrigacao'"></p-sortIcon>
                  </span>
              </span>
              <input class="form-control form-control-sm" type="text"
                (input)="dt1.filter($event.target.value, 'obrigacao', 'contains')">
            </th>
            <th class="text-left" style="width: 30%;">
              <span class="text-overflow-dynamic-container" [pSortableColumn]="'empresa'">
                <span class="text-overflow-dynamic-ellipsis">Empresa <p-sortIcon [field]="'empresa'"></p-sortIcon>
                  </span>
              </span>
              <input class="form-control form-control-sm" type="text"
                (input)="dt1.filter($event.target.value, 'empresa', 'contains')">
            </th>
            <th class="text-center" style="width: 10%;">
              <span class="text-overflow-dynamic-container" [pSortableColumn]="'vencimento'">
                <span class="text-overflow-dynamic-ellipsis">Vencimento <p-sortIcon [field]="'vencimento'"></p-sortIcon>
                  </span>
              </span>
              <input class="form-control form-control-sm" type="text"
                (input)="dt1.filter($event.target.value, 'vencimento', 'contains')">
            </th>
            <th class="text-left" style="width: 15%;">
              <span class="text-overflow-dynamic-container" [pSortableColumn]="'tipoArquivo'">
                <span class="text-overflow-dynamic-ellipsis">Tipo Arquivo <p-sortIcon [field]="'tipoArquivo'">
                  </p-sortIcon></span>
              </span>
              <input class="form-control form-control-sm" type="text"
                (input)="dt1.filter($event.target.value, 'tipoArquivo', 'contains')">
            </th>
            <th class="text-left" style="width: 15%;">
              <span class="text-overflow-dynamic-container" [pSortableColumn]="'responsavel'">
                <span class="text-overflow-dynamic-ellipsis">Responsável <p-sortIcon [field]="'responsavel'">
                  </p-sortIcon></span>
              </span>
              <input class="form-control form-control-sm" type="text"
                (input)="dt1.filter($event.target.value, 'responsavel', 'contains')">
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
          <tr [pSelectableRow]="rowData">
            <td class="text-left" style="width: 30%;">
              <span class="text-overflow-dynamic-container">
                <span class="text-overflow-dynamic-ellipsis"
                  matTooltip="{{rowData.obrigacao}}">{{rowData.obrigacao}}</span>
              </span>
            </td>
            <td class="text-left" style="width: 30%;">
              <span class="text-overflow-dynamic-container">
                <span class="text-overflow-dynamic-ellipsis" matTooltip="{{rowData.empresa}}">{{rowData.empresa}}</span>
              </span>
            </td>
            <td class="text-center" style="width: 10%;">
              <span class="text-overflow-dynamic-container">
                <span class="text-overflow-dynamic-ellipsis"
                  matTooltip="{{rowData.vencimento}}">{{rowData.vencimento}}</span>
              </span>
            </td>
            <td class="text-left" style="width: 15%;">
              <span class="text-overflow-dynamic-container">
                <span class="text-overflow-dynamic-ellipsis"
                  matTooltip="{{rowData.tipoArquivo}}">{{rowData.tipoArquivo}}</span>
              </span>
            </td>
            <td class="text-left" style="width: 15%;">
              <span class="text-overflow-dynamic-container">
                <span class="text-overflow-dynamic-ellipsis"
                  matTooltip="{{rowData.responsavel}}">{{rowData.responsavel}}</span>
              </span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-rowData>
          <tr>
            <td [attr.colspan]="5" class="spaced-alert">
              <div class="alert alert-xs alert-primary d-inline" role="alert">
                <i class="fas fa-info-circle"></i> Nenhum Registro Encontrado!
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </mat-card-content>
</mat-card>